export default function Footer() {
  const handleScroll = (e, target) => {
    e.preventDefault();
    document.querySelector(target)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="contato" data-testid="footer-section" className="relative pt-20 pb-8"
      style={{ background: 'linear-gradient(135deg, #1A8C7A 0%, #0f6b5c 50%, #0a4f44 100%)' }}
    >
      {/* Top wave */}
      <div className="absolute top-0 left-0 w-full rotate-180">
        <svg viewBox="0 0 1440 60" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full" preserveAspectRatio="none">
          <path d="M0,30 C360,60 720,0 1080,30 C1260,45 1380,35 1440,30 L1440,60 L0,60 Z" fill="#F5F5F5" />
        </svg>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Column 1 - Logo & Slogan */}
          <div>
            <img
              src="/images/logos/sindpesca-semfundo.png"
              alt="SINDPESCA"
              className="h-20 sm:h-24 w-auto mb-4 brightness-0 invert"
            />
            <p className="text-white/80 text-sm leading-relaxed mb-6">
              Sindicato dos Pescadores e Pescadoras Artesanais do Estado do Pará e Amapá.
              Defendendo os direitos e a qualidade de vida dos pescadores artesanais.
            </p>
            <div className="flex gap-3">
              <a
                href="https://www.instagram.com/sindpesca_oficial"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center text-white hover:bg-[#E8621A] transition-colors"
              >
                <i className="fab fa-instagram"></i>
              </a>
              <a
                href="https://wa.me/5596991374064"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-whatsapp"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center text-white hover:bg-[#25D366] transition-colors"
              >
                <i className="fab fa-whatsapp"></i>
              </a>
              <a
                href="mailto:sindpesca.pa.ap@gmail.com"
                data-testid="footer-email-icon"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center text-white hover:bg-[#E8621A] transition-colors"
              >
                <i className="fas fa-envelope"></i>
              </a>
            </div>
          </div>

          {/* Column 2 - Quick Links */}
          <div>
            <h3 className="text-white font-bold text-base mb-6">Links Rápidos</h3>
            <nav className="space-y-3">
              {[
                { href: '#inicio', label: 'Início' },
                { href: '#sobre', label: 'Sobre' },
                { href: '#acoes', label: 'Ações Itinerantes' },
                { href: '#cadastro', label: 'Cadastre-se' },
                { href: '#diretores', label: 'Diretores' },
              ].map(link => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={(e) => handleScroll(e, link.href)}
                  className="block text-white/70 text-sm hover:text-white hover:translate-x-1 transition-all duration-300"
                >
                  <i className="fas fa-chevron-right text-[#E8621A] text-xs mr-2"></i>
                  {link.label}
                </a>
              ))}
            </nav>
          </div>

          {/* Column 3 - Contact Info */}
          <div>
            <h3 className="text-white font-bold text-base mb-6">Contato</h3>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <i className="fas fa-map-marker-alt text-[#E8621A] mt-1"></i>
                <p className="text-white/80 text-sm leading-relaxed">
                  Avenida Beira Rio 2023 - A<br />
                  Nova Vida, Almeirim-PA<br />
                  CEP: 68.230-000
                </p>
              </div>
              <div className="flex items-center gap-3">
                <i className="fas fa-phone-alt text-[#E8621A]"></i>
                <a href="tel:+5596991374064" className="text-white/80 text-sm hover:text-white transition-colors">
                  (96) 99137-4064
                </a>
              </div>
              <div className="flex items-center gap-3">
                <i className="fas fa-envelope text-[#E8621A]"></i>
                <a href="mailto:sindpesca.pa.ap@gmail.com" className="text-white/80 text-sm hover:text-white transition-colors">
                  sindpesca.pa.ap@gmail.com
                </a>
              </div>
              <div className="flex items-center gap-3">
                <i className="fab fa-instagram text-[#E8621A]"></i>
                <a href="https://www.instagram.com/sindpesca_oficial" target="_blank" rel="noopener noreferrer" className="text-white/80 text-sm hover:text-white transition-colors">
                  @sindpesca_oficial
                </a>
              </div>
              <div className="flex items-center gap-3">
                <i className="fas fa-globe text-[#E8621A]"></i>
                <a href="https://www.sindpesca.com.br" target="_blank" rel="noopener noreferrer" className="text-white/80 text-sm hover:text-white transition-colors">
                  www.sindpesca.com.br
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-white/20 pt-8 text-center">
          <p className="text-white/60 text-xs sm:text-sm">
            &copy; 2025 SINDPESCA — Todos os direitos reservados
          </p>
        </div>
      </div>
    </footer>
  );
}
